import { render, staticRenderFns } from "./EditVersion.vue?vue&type=template&id=66c37722&"
import script from "./EditVersion.vue?vue&type=script&lang=js&"
export * from "./EditVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports